import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const namespaced = true

export const state = {
         item: {
           id: "",
           category_id: "",
           description: "",
           description1: "",
           description2: "",
           name: "",
           order: 1,
           photo_name: "",
           photo_url: "",
           price: "",
           visible: true,
           featured: false,
           alergenos: [],
         },
         items: [],
         loaded: false,
         dialog: false,
         editMode: false,
         showComponent: false,
       };


export const mutations = {
         SET_SHOW_COMPONENT(state, data) {
           state.showComponent = data;
         },
         SET_EDIT_MODE(state, data) {
           state.editMode = data;
         },
         SET_DIALOG(state, data) {
           state.dialog = data;
         },
         SET_LOADED(state, data) {
           state.loaded = data;
         },
         SET_ITEM(state, data) {
           state.item = data;
         },
         SET_ITEMS(state, data) {
           state.items = data;
         },
         SET_ITEM_DIALOG: (state, data) => {
           state.dialog = !state.dialog;
           state.editMode = data.editMode;
           state.item = data.item;
         },
       };

export const actions = {
	toggleItemDialog({ commit }, data) {
		commit('SET_ITEM_DIALOG', data);
	},
	setLoaded({ commit }, data) {
		commit('SET_LOADED', data)
	},
	setItem({ commit }, data) {
		commit('SET_ITEM', data)
	},

}

export const getters = {
	itemsDialog: (state) => {
		return state.dialog;
	},
	itemForEdit: (state) => {
		return state.item;
	},
	itemDialogEditMode: (state) => {
		return state.editMode;
	},
	itemLoaded: (state) => {
		return state.loaded;
	},

}